import ApplicationController from 'controllers/application-controller'
import lax, { idempotentLaxInit } from 'frontend/lib/lax-with-ext'
import { useIntersection } from 'stimulus-use'

export default class ParallaxController extends ApplicationController {
  static targets = ['items']
  connect () {
    super.connect()
    useIntersection(this)
  }

  appear () {
    this.handleVisible()
  }

  disappear () {
    this.deactivateAnimations(this.activePanel)
  }

  handleVisible () {
    this.initAnimations()
  }

  initAnimations () {
    idempotentLaxInit()
    lax.running || lax.start()

    this.itemsTargets.forEach(item => {
      const animations = {}

      if (item.dataset.scrollY) {
        animations.scrollY = JSON.parse(item.dataset.scrollY)
      }

      lax.addElement(item, animations)
    })
  }

  deactivateAnimations (panel = this.previouslyActivePanel) {
    lax.stop()

    this.itemsTargets.forEach(item => lax.removeElement(item))
  }
}
